/** Visual 1–5 stars (read-only). */
function StarsDisplay({ value }) {
  const n = Math.min(5, Math.max(0, Math.round(Number(value) || 0)));
  return (
    <span className="stars-display text-warning" role="img" aria-label={`${n} out of 5 stars`}>
      {"★".repeat(n)}
      <span className="text-muted opacity-50">{"☆".repeat(5 - n)}</span>
    </span>
  );
}

export default StarsDisplay;
